import _extends from "@babel/runtime/helpers/extends";
import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import UrlGenerator from '../UrlGenerator';
/**
 * UrlGenerator context
 */

export var UrlGeneratorContext = React.createContext(null);
/**
 * useUrlGenerator Hook
 */

export var useUrlGenerator = function useUrlGenerator() {
  return useContext(UrlGeneratorContext);
};
/**
 * withUrlGenerator HOC
 */

export var withUrlGenerator = function withUrlGenerator(WrappedComponent) {
  var getDisplayName = function getDisplayName(_ref) {
    var _ref$displayName = _ref.displayName,
        displayName = _ref$displayName === void 0 ? null : _ref$displayName,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? null : _ref$name;
    return displayName || name || 'Component';
  };

  var WithUrlGeneratorComponent = function WithUrlGeneratorComponent(props) {
    return React.createElement(UrlGeneratorContext.Consumer, null, function (urlGenerator) {
      return React.createElement(WrappedComponent, _extends({
        urlGenerator: urlGenerator
      }, props));
    });
  };

  WithUrlGeneratorComponent.displayName = "WithUrlGenerator(".concat(getDisplayName(WrappedComponent), ")");
  return WithUrlGeneratorComponent;
};
/**
 * UrlGenerator Provider
 */

var propTypes = {
  children: PropTypes.node.isRequired,
  routes: PropTypes.objectOf(PropTypes.string),
  urlGenerator: PropTypes.instanceOf(UrlGenerator)
};
var defaultProps = {
  routes: null,
  urlGenerator: null
};
export var UrlGeneratorProvider = function UrlGeneratorProvider(_ref2) {
  var children = _ref2.children,
      routes = _ref2.routes,
      urlGenerator = _ref2.urlGenerator;
  var value = useMemo(function () {
    return urlGenerator !== null ? urlGenerator : new UrlGenerator(routes);
  }, [routes, urlGenerator]);
  return React.createElement(UrlGeneratorContext.Provider, {
    value: value
  }, children);
};
UrlGeneratorProvider.propTypes = propTypes;
UrlGeneratorProvider.defaultProps = defaultProps;
export default UrlGeneratorContext;